import { useSelector } from 'react-redux';

import { State } from 'store/main';

export function useCurrentUser(): State['currentUser'] | undefined {
  return useSelector((state: State) => state.currentUser);
}
